import { NgModule } from '@angular/core';
import { HisPagesSharedModule } from './his-pages-shared.module';
import { Routes } from '@angular/router';
import { HisSubmenuComponent } from './submenu/his-submenu.component';
import { hisChildRoutes } from '../core/router/his-router';
import { HisAccessDisabledPageComponent } from './access-disabled/his-access-disabled-page.component';

export const ROUTES: Routes = [
    {
        path: 'submenu',
        component: HisSubmenuComponent,
        data: {
            hasAny: ['RIGHT_EVERYONE'],
            modules: ['HISINONE']
        }
    },
    {
        path: 'access-disabled',
        pathMatch: 'full',
        component: HisAccessDisabledPageComponent,
        data: {
            hasAny: ['RIGHT_EVERYONE'],
            modules: ['HISINONE']
        }
    }
];

@NgModule( {
    imports: [
        HisPagesSharedModule,
        hisChildRoutes(ROUTES)
    ],
    exports: [
    ],
    declarations: []
} )
export class HisPagesCoreModule { }
